import { AuditMatch } from '@mi-front/core';
import { usePlayAuditMatch as usePlayAuditMatchHook } from './useAuditPlayback';

export function usePlayAuditMatch(match: AuditMatch) {
  return usePlayAuditMatchHook(match);
}
